const Header = ({ children }) => {
    return (
        <div className="main-list__header">
            {children}
        </div>
    );
};

export default Header;
